package gr.tech.pdfgenerator.components.widgets

import kotlinx.browser.window
import org.w3c.dom.events.Event
import androidx.compose.runtime.*
import org.w3c.dom.BeforeUnloadEvent
import org.w3c.dom.PopStateEvent

@Composable
fun LeaveWarningHandler(hasUnsavedChanges: Boolean) {
    // Reactively attach/detach event listener
    DisposableEffect(hasUnsavedChanges) {
        val handler: (Event) -> Unit = { event ->
            if (hasUnsavedChanges) {
                val e = event as BeforeUnloadEvent
                e.preventDefault()
                e.returnValue = "" // Required for Chrome to show the dialog
            }
        }

        if (hasUnsavedChanges) {
            window.addEventListener("beforeunload", handler)
        }

        onDispose {
            window.removeEventListener("beforeunload", handler)
        }
    }
}

//@Composable
//fun BackButtonGuard(hasUnsavedChanges: Boolean) {
//
//    // Capture history changes like back/forward in SPA
//    DisposableEffect(hasUnsavedChanges) {
//        val handler: (Event) -> Unit = { event ->
//            if (hasUnsavedChanges) {
//                val e = event as PopStateEvent
//                e.preventDefault()
//
//                val confirm = window.confirm("You have unsaved changes. Leave anyway?")
//                console.log(confirm)
//                if (!confirm) {
//                    // Push current state back to re-cancel navigation
//                    window.history.pushState(null, "", window.location.href)
//                }
//            }
//        }
//
//        window.addEventListener("popstate", handler)
//
//        onDispose {
//            window.removeEventListener("popstate", handler)
//        }
//    }
//}
